import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import * as XLSX from 'xlsx';

import { ApiLoginService } from '@app/api/api-login.service';
import { ApiContentService } from '@app/api/api-content.service';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { LoadJsService } from '../../load-js/load-js.service';

@Component({
  selector: 'app-orderservice',
  templateUrl: './orderservice.component.html',
  styleUrls: ['./orderservice.component.css']
})
export class OrderserviceComponent implements OnInit {
  @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;

  constructor(
    public restApi:ApiPartnerService,
    private fb: FormBuilder,
    private login: ApiLoginService,
    public partnerService: ApiPartnerService,
    public LoadJsOrder: LoadJsService,
  ) { }

  formView = this.fb.group({
    id : ['']
  });
  form_upload = this.fb.group({
    type : [''],
    name_file: [''],
    value_upload: ['']
  });

  formOrder = this.fb.group({
    partnerid: [''],
    tgl_order: [''],
    grf_number: [''],
    iom_number: [''],
    value_upload: ['']
  })
  formOrderReupload = this.fb.group({
    value_upload: [''],
    id: ['']
  })
  btn_save = true
  btn_loading = false
  loading_create = false
  alert_failed = false
  alert_success = false

  table_load = false
  table_data = false
  form_create = false
  
  data_order_service:any={}
  data_partner:any={}
  response_api:any={}

  ngOnInit() {
     this.LoadJsOrder.loadScriptOrderStb()
    this.orderService()
    this.partner()
  }
  refreshPage() {
    this.table_data = false
     this.LoadJsOrder.loadScriptOrderStb()
    this.orderService()
    this.partner()
  }

  orderService() {
    this.table_load = true
    this.restApi.GetOrderService('').subscribe((data: {}) => { 
      this.data_order_service = data
      console.log(this.data_order_service)
        this.table_load = false
        this.table_data = true
    });  
  }
  partner() {
    this.restApi.GetPartner().subscribe((data: {}) => { 
      this.data_partner = data
      // console.log(this.data_order_service)
    });  
  }
  getView(id) {
    this.restApi.ViewOrderService(id)
      .subscribe((data: {}) => { 
        this.response_api = data
        console.log(this.response_api)
      }
    );
  }

  back() {
    this.form_create = false;
  }

  reset(form: NgForm){
    form.reset(); // or form.resetForm();
  }
}
